import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api/`;
const resource = 'application';

export default {
    index(page = 1, per_page = 15, order_column = 'id', order_direction = 'desc', search = '', filter = '') {
        return resources.get(`${resource}?page=${page}&per_page=${per_page}&order_column=${order_column}&order_direction=${order_direction}${filter}&search=${search}`);
    },
    show(id) {
        return resources.get(`${resource}/${id}`);
    },
    store() {
        return `${baseUrl}${resource}`
    },
    acquirers() {
        return resources.get('acquirers');
    },
    note(id) {
        return `${baseUrl}${resource}/${id}/notes`
    },
    pinNote(note) {
        return `${baseUrl}notes/${note}/pin`
    },
    update(id) {
        return `${baseUrl}${resource}/${id}`;
    },
    destroy(id) {
        return resources.delete(`${resource}/${id}`);
    },
    statuses() {
        return resources.get(`${baseUrl}applicationStatus`);
    },
    bankStatuses() {
        return resources.get(`${baseUrl}applicationBankStatus`);
    },
    feed(id) {
        return resources.get(`${baseUrl}${resource}/${id}/feed`);
    },
    statusUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-status`;
    },
    entityIdUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-merchant-entity-id`;
    },
    membersUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-members`;
    },
    outsourcePartnerUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-outsource`;
    },
    bankStatusUpdate(id) {
        return `${baseUrl}${resource}/${id}/update-bank-status`;
    },
    rateUpdateOrCreate(id) {
        return `${baseUrl}${resource}/${id}/rate`;
    },
    downloadApplication(application, acquirer) {
        return `${baseUrl}${resource}/generate-application/${application}/${acquirer}`;
    },
    statusReasons() {
        return resources.get(`${baseUrl}${resource}/status/reasons`);
    },
    filterData() {
        return resources.get(`${baseUrl}application-filters`);
    },
}
